export default "__VITE_ASSET__DVSXbufX__"